
import { useState } from 'react';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Shirley Figueroa",
      role: "Cliente satisfecha",
      image: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/4b743715b4fa45f52976ee83a9e8432e.jfif",
      rating: 5,
      text: "Contratar a Idoel Photography para cualquier tipo de sección de fotos vale la pena. Trabajó mi Love Story más mi boda y debo decir que ejecuta con profesionalismo y DEDICACIÓN. Es espontáneo, creativo y versátil. Su intención es captar los mejores momentos en tu sección de fotos. Te da la confianza de que te sientas a gusto y que seas tú. Te darás cuenta que Idoel disfruta el proceso tanto como tú mientras sucede."
    },
    {
      name: "MarLee Ruiz Cordero",
      role: "Familia feliz",
      image: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/52b2d9be8b9dbe3db23e121013bc19d7.jfif",
      rating: 5,
      text: "Por 4ta vez decidimos hacer nuestra sección de fotos familiar y la EXPERIENCIA fue única. Súper contentos y agradecidos con la forma de trabajar los niños y las mascotas. Un trabajo excelente. Estamos ansiosos por volver a repetirla."
    },
    {
      name: "Jossie Ann",
      role: "Madre orgullosa",
      image: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/f94e48225f1ed17c19ab7eed9960175f.jfif",
      rating: 5,
      text: "Fue mi primera experiencia con mi hija y con mi familia perruna. Definitivamente su atención, trato, cordialidad fue y van de la mano del servicio 5 Estrella ⭐️ que me brindó el caballero. Sobrepaso mis expectativas estoy más que satisfecha y complacida de su servicio. Gente se lo garantizo no me equivoque en seleccionarlo ! Gracias Idoel y Dios siga derramando éxito en su vida y la de su hermosa familia."
    }
  ];

  const [showConsultModal, setShowConsultModal] = useState(false);
  const [consultFormData, setConsultFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleConsultInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setConsultFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleConsultSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    try {
      if (consultFormData.message.length > 500) {
        setSubmitStatus('error');
        return;
      }

      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', consultFormData.name);
      formDataToSend.append('email', consultFormData.email);
      formDataToSend.append('phone', consultFormData.phone);
      formDataToSend.append('message', consultFormData.message);

      const response = await fetch('https://readdy.ai/api/form/d3dkeurbr3iihosg1bsg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setConsultFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
        setTimeout(() => {
          setShowConsultModal(false);
          setSubmitStatus('');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(''), 5000);
    }
  };

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 relative bg-black">
      {/* Fondo estrellado */}
      <div className="absolute inset-0">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse opacity-20"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div className="w-0.5 h-0.5 rounded-full bg-gold-500"></div>
          </div>
        ))}
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Título de la sección */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight font-serif text-gold-500">
            Historias que Brillan
          </h2>
          <div className="w-16 sm:w-24 h-px mx-auto mb-6 sm:mb-8 bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed px-2 font-sans">
            Descubre lo que nuestros clientes dicen sobre su experiencia mágica con Idoel Photography.
          </p>
        </div>

        {/* Grid de testimonios */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-b from-gray-900/60 to-gray-800/40 backdrop-blur-sm border border-gold-500/30 rounded-2xl p-6 sm:p-8 hover:scale-105 transition-all duration-300">
              {/* Estrellas */}
              <div className="flex space-x-1 mb-4 sm:mb-6">
                {[...Array(testimonial.rating)].map((_, starIndex) => (
                  <i key={starIndex} className="ri-star-fill text-lg sm:text-xl text-gold-500"></i>
                ))}
              </div>

              {/* Testimonio */}
              <blockquote className="text-sm sm:text-base text-gray-300 leading-relaxed mb-6 sm:mb-8 italic font-sans">
                "{testimonial.text}"
              </blockquote>

              {/* Información del cliente */}
              <div className="flex items-center space-x-3 sm:space-x-4">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover object-top border-2 border-gold-500"
                />
                <div>
                  <div className="font-semibold text-sm sm:text-base text-gold-500 font-serif">
                    {testimonial.name}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-400 font-sans">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-16">
          <p className="text-base sm:text-lg text-gray-300 mb-6 font-sans">
            ¿Listo para crear tu propia historia mágica?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={() => {
                const servicesSection = document.getElementById('services-section');
                if (servicesSection) {
                  servicesSection.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                  });
                } else {
                  // Fallback: buscar la sección de servicios de diferentes maneras
                  const servicesElement = document.querySelector('[id="services-section"]') || 
                                        document.querySelector('section:has(h2:contains("Nuestros Servicios"))') ||
                                        document.querySelector('section:nth-of-type(3)');
                  if (servicesElement) {
                    servicesElement.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                    });
                  }
                }
              }}
              className="text-black font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-600 hover:to-gold-700 font-sans"
            >
              Reserva tu Sesión Ahora
            </button>
            <button 
              onClick={() => setShowConsultModal(true)}
              className="text-gold-500 font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-xl border-2 border-gold-500 transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-gold-500/10 font-sans"
            >
              Consulta Personalizada
            </button>
          </div>
          
          {/* Métodos de pago */}
          <div className="mt-8">
            <p className="text-sm text-gray-400 font-sans">
              Pagos seguros vía ATH Móvil, PayPal y Tarjeta de Crédito
            </p>
            <p className="text-sm text-gray-400 mt-1 font-sans">
              <span className="text-gold-500">Reserva ahora y paga después</span> con Klarna - Sin intereses
            </p>
          </div>

        </div>

        {/* Modal de consulta */}
        {showConsultModal && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-gradient-to-b from-gray-900/90 to-gray-800/90 backdrop-blur-sm border border-gold-500/30 rounded-2xl p-6 sm:p-8 max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl sm:text-2xl font-bold font-serif text-gold-500">
                  Consulta Personalizada
                </h3>
                <button 
                  onClick={() => setShowConsultModal(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-700/50 hover:bg-gray-600/50 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-white"></i>
                </button>
              </div>

              <p className="text-gray-300 mb-6 text-sm font-sans">
                ¿Tienes dudas sobre nuestros paquetes o necesitas ayuda para elegir el servicio perfecto? Escríbenos y te ayudaremos.
              </p>

              <form id="consult-form" data-readdy-form onSubmit={handleConsultSubmit} className="space-y-4">
                <div>
                  <label className="block font-medium mb-2 text-sm text-gold-500 font-sans">Nombre</label>
                  <input
                    type="text"
                    name="name"
                    value={consultFormData.name}
                    onChange={handleConsultInputChange}
                    required
                    className="w-full bg-gray-800/50 border border-gray-600/50 rounded-xl px-3 py-2 text-white focus:outline-none focus:border-gold-500 transition-colors text-sm font-sans"
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-2 text-sm text-gold-500 font-sans">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={consultFormData.email}
                    onChange={handleConsultInputChange}
                    required
                    className="w-full bg-gray-800/50 border border-gray-600/50 rounded-xl px-3 py-2 text-white focus:outline-none focus:border-gold-500 transition-colors text-sm font-sans"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-2 text-sm text-gold-500 font-sans">Teléfono</label>
                  <input
                    type="tel"
                    name="phone"
                    value={consultFormData.phone}
                    onChange={handleConsultInputChange}
                    className="w-full bg-gray-800/50 border border-gray-600/50 rounded-xl px-3 py-2 text-white focus:outline-none focus:border-gold-500 transition-colors text-sm font-sans"
                    placeholder="(787) 123-4567"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-2 text-sm text-gold-500 font-sans">Tu consulta</label>
                  <textarea
                    name="message"
                    value={consultFormData.message}
                    onChange={handleConsultInputChange}
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full bg-gray-800/50 border border-gray-600/50 rounded-xl px-3 py-2 text-white focus:outline-none focus:border-gold-500 transition-colors text-sm resize-none font-sans"
                    placeholder="Cuéntanos qué tipo de sesión necesitas, fechas, dudas sobre paquetes..."
                  ></textarea>
                  <div className="text-right text-gray-400 text-xs mt-1 font-sans">
                    {consultFormData.message.length}/500 caracteres
                  </div>
                </div>

                {/* Estado del envío */}
                {submitStatus === 'success' && (
                  <div className="bg-pine-500/20 border border-pine-500/50 rounded-xl p-3 text-pine-300 text-sm font-sans">
                    ¡Consulta enviada exitosamente! Te contactaremos pronto.
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="bg-cherry-500/20 border border-cherry-500/50 rounded-xl p-3 text-cherry-300 text-sm font-sans">
                    Error al enviar la consulta. Por favor, inténtalo de nuevo.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting || consultFormData.message.length > 500}
                  className="w-full text-black font-semibold py-3 px-6 rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed text-sm bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-600 hover:to-gold-700 font-sans"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center">
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Enviando...
                    </span>
                  ) : (
                    'Enviar Consulta'
                  )}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
